// import React, { useState, useEffect } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { useFetchGetMe } from "hooks/usersHooks";
// import { useTranslation } from "react-i18next";
// import { Select } from "antd";
// import { NavLink } from "react-router-dom";
// import * as motion from "motion/react-client";

// interface SelectOptionType {
//   label: string;
//   value: string;
// }
// export const langOptions: Array<SelectOptionType> = [
//   { label: "Рус", value: "ru" },
//   { label: "Uzb", value: "uz" },
//   { label: "Eng", value: "en" },
// ];

// type role = {
//   userRole: any;
// };

// const Sidebar = ({ userRole }: role) => {
//   const { t } = useTranslation();
//   const [open1, setOpen1] = useState<boolean>(false);
//   const { data: userItem } = useFetchGetMe();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const isActiveUsers =
//     location.pathname.startsWith("/users/student") ||
//     location.pathname.startsWith("/users/employee");

//   const { i18n } = useTranslation();
//   const [lang, setLang] = useState<SelectOptionType | string>(langOptions[1]);

//   useEffect(() => {
//     const currentLanguageOption =
//       langOptions.find((option) => option.value === i18n.language) ||
//       langOptions[1];

//     setLang(currentLanguageOption);
//   }, [i18n.language]);

//   const handleChangeLanguage = (val: any) => {
//     i18n.changeLanguage(val);
//     setLang(val);
//   };

//   const handleClick = () => {
//     setOpen1(!open1);
//   };

//   const isActive = (path: string) =>
//     location.pathname === path ? "active-menu" : "";

//   return (
//     <motion.div
//       initial={{ opacity: 0, x: -20 }}
//       animate={{ opacity: 1, x: 0 }}
//       transition={{ duration: 0.5, delay: 1 }}
//       className="main-side-bar"
//     >
//       <div className="my-side-fix">
//         <div className="top-logo">
//           <Link to="/">
//             <img src="/img/Logowrap.png" alt="..." className="logo-company" />
//           </Link>
//           {/* <Select
//             options={langOptions}
//             style={{ width: "80px", marginBottom: "0.5rem" }}
//             value={lang}
//             onChange={handleChangeLanguage}
//           /> */}
//         </div>
//         <div className="mid-side">
//           <div className="mid-side-top">
//             {userItem?.roles[0]?.name === "Teacher" ||
//             userItem?.roles[0]?.name === "Admin" ? (
//               <>
//                 <div
//                   className={`link-item-style d-flex justify-content-between align-items-center ${
//                     open1 ? "active-menu" : ""
//                   }`}
//                   onClick={handleClick}
//                 >
//                   <span>
//                     <span className="icon icon-analitcs" />
//                     <span className="menu-item-style font-family-openSans-SemiBold">
//                       {t("common.analytics.analytics")}
//                     </span>
//                   </span>
//                   {open1 ? (
//                     <span className="icon icon-chevronup" />
//                   ) : (
//                     <span className="icon icon-chevronup icon-chevrondown" />
//                   )}
//                 </div>
//                 {open1 && (
//                   <div>
//                     {userItem?.roles[0]?.name === "Admin" && (
//                       <NavLink
//                         to="/analytics/students"
//                         className={`link-item-style-child`}
//                       >
//                         {t("common.main")}
//                       </NavLink>
//                     )}
//                     <NavLink
//                       // to="/analytics/teachers"
//                       to="/analytics/faculty"
//                       className={`link-item-style-child`}
//                     >
//                       {t("common.users.faculty")}
//                     </NavLink>
//                     <NavLink
//                       to="/analytics/directions"
//                       className={`link-item-style-child`}
//                     >
//                       {t("common.analytics.directions")}
//                     </NavLink>
//                     <NavLink
//                       to="/analytics/groups"
//                       className={`link-item-style-child`}
//                     >
//                       {t("common.group")}
//                     </NavLink>
//                     <NavLink
//                       to="/analytics/subjects"
//                       className={`link-item-style-child`}
//                     >
//                       {t("common.element")}
//                     </NavLink>
//                     <NavLink
//                       to="/users/student"
//                       className={`link-item-style-child ${
//                         isActiveUsers ? "active" : ""
//                       }`}
//                     >
//                       {t("common.usersSidebar")}
//                     </NavLink>
//                   </div>
//                 )}
//               </>
//             ) : null}

//             {userItem?.roles[0]?.name === "Admin" && (
//               <>
//                 <Link to="/" className={`link-item-style ${isActive("/")}`}>
//                   <span className="icon icon-liveico" />
//                   <span className="menu-item-style font-family-openSans-SemiBold">
//                     Dars davomati
//                   </span>
//                 </Link>
//                 <Link
//                   to="/uploads"
//                   className={`link-item-style ${isActive("/uploads")}`}
//                 >
//                   <span className="icon icon-person" />
//                   <span className="menu-item-style font-family-openSans-SemiBold">
//                     Rasm yuklash
//                   </span>
//                 </Link>
//                 <Link
//                   to="/cameras"
//                   className={`link-item-style ${isActive("/cameras")}`}
//                 >
//                   <span className="icon icon-liveico" />
//                   <span className="menu-item-style font-family-openSans-SemiBold">
//                     {t("common.cameras.cameras")}
//                   </span>
//                 </Link>
//                 <Link
//                   to="/class-schedule"
//                   className={`link-item-style ${isActive("/class-schedule")}`}
//                 >
//                   <span className="icon icon-calendar" />
//                   <span className="menu-item-style font-family-openSans-SemiBold">
//                     {t("common.classSchedule")}
//                   </span>
//                 </Link>
//                 <Link
//                   to="/university/buildings/1"
//                   className={`link-item-style ${isActive(
//                     "/university/buildings/1"
//                   )}`}
//                 >
//                   <span className="icon icon-buildings" />
//                   <span className="menu-item-style font-family-openSans-SemiBold">
//                     {t("common.buildings")}
//                   </span>
//                 </Link>
//               </>
//             )}

//             {userItem?.roles[0]?.name === "Admin" && (
//               <>
//                 <Link
//                   to="/roi"
//                   className={`link-item-style ${isActive("/roi")}`}
//                 >
//                   <span className="icon icon-roi" />
//                   <span className="menu-item-style font-family-openSans-SemiBold">
//                     {/* {t("common.roi.roi")} */}
//                     ROI
//                   </span>
//                 </Link>
//                 <Link
//                   to="/roleUsers"
//                   className={`link-item-style ${isActive("/roleUsers")}`}
//                 >
//                   <span className="icon icon-roi" />
//                   <span className="menu-item-style font-family-openSans-SemiBold">
//                     {/* {t("common.roi.roi")} */}
//                     User management
//                   </span>
//                 </Link>
//               </>
//             )}
//           </div>

//           <div className="mid-side-top">
//             <div className="acc-profile text-decoration-none">
//               <div
//                 className="d-flex cursor-pointer"
//                 onClick={() =>
//                   userItem?.user?.profile_type === "student"
//                     ? navigate(
//                         "/analytics/students/student-profile/" +
//                           userItem?.user?.id
//                       )
//                     : userItem?.user?.profile_type === "employee" &&
//                       userItem?.user?.username !== "admin"
//                     ? navigate(
//                         "/analytics/teachers/teacher-profile/" +
//                           userItem?.user?.id
//                       )
//                     : userItem?.user?.username === "admin"
//                     ? navigate("/user-detail")
//                     : ""
//                 }
//               >
//                 <div className="acc-img">
//                   <img src="/img/adminUser.png" alt="user" width="40" />
//                 </div>
//                 <div className="acc-content">
//                   <h5 className="font-family-openSans-SemiBold">
//                     {userItem?.username}
//                   </h5>
//                   <h6 className="font-family-openSans-Regular">
//                     {userItem?.user?.profile_type}
//                   </h6>
//                 </div>
//               </div>
//               <div>
//                 <button
//                   className="acc-toggle"
//                   onClick={() => {
//                     localStorage.removeItem("token");
//                     localStorage.removeItem("user_id");
//                     navigate("/login");
//                   }}
//                 >
//                   <span className="icon icon-logout" />
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </motion.div>
//   );
// };

// export default Sidebar;
import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useFetchGetMe } from "hooks/usersHooks";
import { useTranslation } from "react-i18next";
import * as motion from "motion/react-client";
import { can, myDirectionIds, myFacultyIds } from "utils/access";
import { DIRECTION_ROLES, FACULTY_ROLES, RECTOR_ROLES } from "utils/roles";

type SidebarProps = {
  /** Normalized lowercase role names from ProtectedRoute */
  userRole: string | string[];
};

const Sidebar = ({ userRole }: SidebarProps) => {
  const { t } = useTranslation();
  const { data: userItem } = useFetchGetMe({ enabled: true });
  const navigate = useNavigate();
  const location = useLocation();

  // console.log(userItem);

  const [openAnalytics, setOpenAnalytics] = useState(false);
  const [openLocation, setOpenLocation] = useState(false);

  const isActive = (path: string) =>
    location.pathname === path ? "active-menu" : "";

  const isActiveUsers =
    location.pathname.startsWith("/users/student") ||
    location.pathname.startsWith("/users/employee");

  const roleList = Array.isArray(userRole)
    ? userRole
    : userRole
      ? [String(userRole).toLowerCase()]
      : [];
  const isAdmin = roleList.includes("admin");
  const isSuperAdmin = roleList.includes("super_admin");
  const isRektor = roleList.some((r) => RECTOR_ROLES.includes(r));
  const isRestrictedOther =
    !!userItem?.access?.restricted &&
    !roleList.some((r) => [...RECTOR_ROLES, ...DIRECTION_ROLES, "admin", "super_admin"].includes(r));
  const isFacultyAdmin = roleList.some((r) => FACULTY_ROLES.includes(r)) || isRestrictedOther;
  const isDirectionAdmin = roleList.some((r) => DIRECTION_ROLES.includes(r));
  const facultyIds = myFacultyIds(userItem);
  const directionIds = myDirectionIds(userItem);
  const facultyLink =
    facultyIds.length === 1 ? `/analytics/faculty/0/${facultyIds[0]}` : "/analytics/faculty";
  const directionLink =
    directionIds.length === 1 ? `/analytics/directions/${directionIds[0]}` : "/analytics/directions";
  const canManageAccess = can(userItem, "view_user-access");
  const canManageRoles = can(userItem, "view_roles");
  const isTeacher = roleList.includes("teacher");
  const isStudent = roleList.includes("student");
  const [openImages, setOpenImages] = useState(false);
  const [openExams, setOpenExams] = useState(false);
  useEffect(() => {
    if (isFacultyAdmin || isRektor || isDirectionAdmin) {
      setOpenAnalytics(() => true);
    }
  }, [isDirectionAdmin, isFacultyAdmin, isRektor]);

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.25, delay: 0 }}
      className="main-side-bar"
    >
      <div className="my-side-fix">
        {/* LOGO */}
        <div className="top-logo">
          <Link to="/">
            <img
              src="/logo.svg"
              alt="logo"
              className="logo-company w-100 h-100 object-fit-contain"
            />
          </Link>
        </div>

        <div className="mid-side">
          <div className="mid-side-top">
            {/* ---------------- ANALYTICS ---------------- */}
            {isRektor && (
              <>
                <div
                  className={`link-item-style d-flex justify-content-between align-items-center ${openAnalytics ? "active-menu" : ""
                    }`}
                  onClick={() => setOpenAnalytics(!openAnalytics)}
                >
                  <span>
                    <span className="icon icon-analitcs" />
                    <span className="menu-item-style font-family-openSans-SemiBold">
                      {t("common.analytics.analytics")}
                    </span>
                  </span>
                  <span
                    className={`icon ${openAnalytics
                      ? "icon-chevronup"
                      : "icon-chevronup icon-chevrondown"
                      }`}
                  />
                </div>

                {openAnalytics && (
                  <div>
                    <NavLink
                      to="/analytics/faculty"
                      className="link-item-style-child"
                    >
                      {t("common.users.faculty")}
                    </NavLink>

                    <NavLink
                      to="/analytics/directions"
                      className="link-item-style-child"
                    >
                      {t("common.analytics.directions")}
                    </NavLink>

                    <NavLink
                      to="/analytics/groups"
                      className="link-item-style-child"
                    >
                      {t("common.group")}
                    </NavLink>

                    <NavLink
                      to="/analytics/subjects"
                      className="link-item-style-child"
                    >
                      {t("common.element")}
                    </NavLink>

                    <NavLink
                      to="/users/student"
                      className={`link-item-style-child ${isActiveUsers ? "active" : ""
                        }`}
                    >
                      {t("common.usersSidebar")}
                    </NavLink>
                  </div>
                )}
              </>
            )}

            {(isAdmin || isSuperAdmin) && (
              <>
                <>
                  <div
                    className={`link-item-style d-flex justify-content-between align-items-center ${openAnalytics ? "active-menu" : ""
                      }`}
                    onClick={() => setOpenAnalytics(!openAnalytics)}
                  >
                    <span>
                      <span className="icon icon-analitcs" />
                      <span className="menu-item-style font-family-openSans-SemiBold">
                        {t("common.analytics.analytics")}
                      </span>
                    </span>
                    <span
                      className={`icon ${openAnalytics
                        ? "icon-chevronup"
                        : "icon-chevronup icon-chevrondown"
                        }`}
                    />
                  </div>

                  {openAnalytics && (
                    <div>
                      {(isAdmin || isSuperAdmin) && (
                        <NavLink
                          to="/analytics/students"
                          className="link-item-style-child"
                        >
                          {t("common.main")}
                        </NavLink>
                      )}

                      <NavLink
                        to="/analytics/faculty"
                        className="link-item-style-child"
                      >
                        {t("common.users.faculty")}
                      </NavLink>

                      <NavLink
                        to="/analytics/directions"
                        className="link-item-style-child"
                      >
                        {t("common.analytics.directions")}
                      </NavLink>

                      <NavLink
                        to="/analytics/groups"
                        className="link-item-style-child"
                      >
                        {t("common.group")}
                      </NavLink>

                      <NavLink
                        to="/analytics/subjects"
                        className="link-item-style-child"
                      >
                        {t("common.element")}
                      </NavLink>

                      <NavLink
                        to="/users/student"
                        className={`link-item-style-child ${isActiveUsers ? "active" : ""
                          }`}
                      >
                        {t("common.usersSidebar")}
                      </NavLink>
                    </div>
                  )}
                </>


                <div
                  className={`link-item-style d-flex justify-content-between align-items-center ${openImages ? "active-menu" : ""
                    }`}
                  onClick={() => setOpenImages(!openImages)}
                >
                  <span>
                    <span className="icon icon-export" />
                    <span className="menu-item-style font-family-openSans-SemiBold">
                      {t("common.sidebar.images")}
                    </span>
                  </span>
                  <span
                    className={`icon ${openImages
                      ? "icon-chevronup"
                      : "icon-chevronup icon-chevrondown"
                      }`}
                  />
                </div>

                {openImages && (
                  <div>
                    <NavLink
                      to="/uploads"
                      className="link-item-style-child"
                    >
                      {t("common.sidebar.uploadImage")}
                    </NavLink>

                    <NavLink
                      to="/no-image-faculties"
                      className="link-item-style-child"
                    >
                      {t("common.sidebar.imagesList")}
                    </NavLink>
                  </div>
                )}
                {isSuperAdmin ? (
                  <NavLink
                    to="/hemis-sync"
                    className={`link-item-style ${isActive("/hemis-sync")}`}
                  >
                    <span className="icon icon-export" />
                    <span className="menu-item-style font-family-openSans-SemiBold">
                      HEMIS Sync
                    </span>
                  </NavLink>
                ) : null}
                <div
                  className={`link-item-style d-flex justify-content-between align-items-center ${openLocation ? "active-menu" : ""
                    }`}
                  onClick={() => setOpenLocation(!openLocation)}
                >
                  <span>
                    <span className="icon icon-checkdone" />
                    <span className="menu-item-style font-family-openSans-SemiBold">
                      {t("common.sidebar.location")}
                    </span>
                  </span>
                  <span
                    className={`icon ${openLocation
                      ? "icon-chevronup"
                      : "icon-chevronup icon-chevrondown"
                      }`}
                  />
                </div>
                {openLocation && (
                  <div>

                    <NavLink
                      to="/location/list"
                      className="link-item-style-child"
                    >
                      {t("common.sidebar.locationsList")}
                    </NavLink>
                    <NavLink
                      to="/location/connect/list"
                      className="link-item-style-child"
                    >
                      {t("common.sidebar.practices")}                   
                       </NavLink>
                        <NavLink
                      to="/practical-schedules-attandance"
                      className="link-item-style-child"
                    >
                      {t("common.sidebar.practicesAttendance")}                  
                       </NavLink>
                  </div>

                )}

                <div
                  className={`link-item-style d-flex justify-content-between align-items-center ${openExams ? "active-menu" : ""
                    }`}
                  onClick={() => setOpenExams(!openExams)}
                >
                  <span>
                    <span className="icon icon-shapka" />
                    <span className="menu-item-style font-family-openSans-SemiBold">
                      {t("common.sidebar.exams")}
                    </span>
                  </span>
                  <span
                    className={`icon ${openExams
                      ? "icon-chevronup"
                      : "icon-chevronup icon-chevrondown"
                      }`}
                  />
                </div>

                {openExams && (
                  <div>
                    <NavLink
                      to="/exams/"
                      className={({ isActive }) =>
                        "link-item-style-child" + (isActive ? " active" : "")
                      }
                      end
                    >
                      {t("common.sidebar.examsSchedule")}
                    </NavLink>
                    <NavLink
                      to="/exams/analytics"
                      className={({ isActive }) =>
                        "link-item-style-child" + (isActive ? " active" : "")
                      }
                    >
                      {t("common.sidebar.examsAttendance")}
                    </NavLink>
                  </div>
                )}
                <Link to="/" className={`link-item-style ${isActive("/")}`}>
                  <span className="icon icon-calendar" />
                  <span className="menu-item-style font-family-openSans-SemiBold">
                    {t("common.sidebar.lessonAttendance")}
                  </span>
                </Link>
                <Link
                  to="/cameras"
                  className={`link-item-style ${isActive("/cameras")}`}
                >
                  <span className="icon icon-liveico" />
                  <span className="menu-item-style font-family-openSans-SemiBold">
                    {t("common.cameras.cameras")}
                  </span>
                </Link>


                <Link
                  to="/class-schedule"
                  className={`link-item-style ${isActive("/class-schedule")}`}
                >
                  <span className="icon icon-calendar" />
                  <span className="menu-item-style font-family-openSans-SemiBold">
                    {t("common.classSchedule")}
                  </span>
                </Link>

                <Link
                  to="/university/buildings/1"
                  className={`link-item-style ${isActive(
                    "/university/buildings/1"
                  )}`}
                >
                  <span className="icon icon-buildings" />
                  <span className="menu-item-style font-family-openSans-SemiBold">
                    {t("common.buildings")}
                  </span>
                </Link>
                <Link
                  to="/roleUsers"
                  className={`link-item-style ${isActive("/roleUsers")}`}
                >
                  <span className="icon icon-person" />
                  <span className="menu-item-style font-family-openSans-SemiBold">
                    {t("common.sidebar.userManagement")}
                  </span>
                </Link>
                <Link
                  to="/users/add-roles"
                  className={`link-item-style ${isActive("/users/add-roles")}`}
                >
                  <span className="icon icon-person" />
                  <span className="menu-item-style font-family-openSans-SemiBold">
                    {t("common.roleManagement")}
                  </span>
                </Link>
                <Link
                  to="/roi"
                  className={`link-item-style ${isActive("/roi")}`}
                >
                  <span className="icon icon-roi" />
                  <span className="menu-item-style font-family-openSans-SemiBold">
                    {t("common.sidebar.roi")}
                  </span>
                </Link>


              </>
            )}

            {isFacultyAdmin && (
              <>
                <>
                  <div
                    className={`link-item-style d-flex justify-content-between align-items-center ${openAnalytics ? "active-menu" : ""
                      }`}
                    onClick={() => setOpenAnalytics(!openAnalytics)}
                  >
                    <span>
                      <span className="icon icon-analitcs" />
                      <span className="menu-item-style font-family-openSans-SemiBold">
                        {t("common.analytics.analytics")}
                      </span>
                    </span>
                    <span
                      className={`icon ${openAnalytics
                        ? "icon-chevronup"
                        : "icon-chevronup icon-chevrondown"
                        }`}
                    />
                  </div>

                  {openAnalytics && (
                    <div>
                      <NavLink
                        to={facultyLink}
                        className="link-item-style-child"
                      >
                        {t("common.users.faculty")}
                      </NavLink>

                      <NavLink
                        to="/analytics/directions"
                        className="link-item-style-child"
                      >
                        {t("common.analytics.directions")}
                      </NavLink>

                      <NavLink
                        to="/analytics/groups"
                        className="link-item-style-child"
                      >
                        {t("common.group")}
                      </NavLink>

                      <NavLink
                        to="/analytics/subjects"
                        className="link-item-style-child"
                      >
                        {t("common.element")}
                      </NavLink>

                      <NavLink
                        to="/users/student"
                        className={`link-item-style-child ${isActiveUsers ? "active" : ""
                          }`}
                      >
                        {t("common.usersSidebar")}
                      </NavLink>
                    </div>
                  )}
                </>
              </>
            )}

            {isDirectionAdmin && (
              <>
                <>
                  <div
                    className={`link-item-style d-flex justify-content-between align-items-center ${openAnalytics ? "active-menu" : ""
                      }`}
                    onClick={() => setOpenAnalytics(!openAnalytics)}
                  >
                    <span>
                      <span className="icon icon-analitcs" />
                      <span className="menu-item-style font-family-openSans-SemiBold">
                        {t("common.analytics.analytics")}
                      </span>
                    </span>
                    <span
                      className={`icon ${openAnalytics
                        ? "icon-chevronup"
                        : "icon-chevronup icon-chevrondown"
                        }`}
                    />
                  </div>

                  {openAnalytics && (
                    <div>
                      <NavLink
                        to={directionLink}
                        className="link-item-style-child"
                      >
                        {t("common.analytics.directions")}
                      </NavLink>

                      <NavLink
                        to="/analytics/groups"
                        className="link-item-style-child"
                      >
                        {t("common.group")}
                      </NavLink>

                      <NavLink
                        to="/analytics/subjects"
                        className="link-item-style-child"
                      >
                        {t("common.element")}
                      </NavLink>

                      <NavLink
                        to="/users/student"
                        className={`link-item-style-child ${isActiveUsers ? "active" : ""
                          }`}
                      >
                        {t("common.usersSidebar")}
                      </NavLink>
                    </div>
                  )}
                </>
              </>
            )}

            {!(isAdmin || isSuperAdmin) && canManageAccess && (
              <Link
                to="/roleUsers"
                className={`link-item-style ${isActive("/roleUsers")}`}
              >
                <span className="icon icon-person" />
                <span className="menu-item-style font-family-openSans-SemiBold">
                  {t("common.sidebar.userManagement")}
                </span>
              </Link>
            )}
            {!(isAdmin || isSuperAdmin) && canManageRoles && (
              <Link
                to="/users/add-roles"
                className={`link-item-style ${isActive("/users/add-roles")}`}
              >
                <span className="icon icon-person" />
                <span className="menu-item-style font-family-openSans-SemiBold">
                  {t("common.roleManagement")}
                </span>
              </Link>
            )}

            {(isTeacher || isStudent) && (
              <Link
                to="/class-schedule"
                className={`link-item-style ${isActive("/class-schedule")}`}
              >
                <span className="icon icon-calendar" />
                <span className="menu-item-style font-family-openSans-SemiBold">
                  {t("common.classSchedule")}
                </span>
              </Link>
            )}
          </div>

          {/* ---------------- PROFILE ---------------- */}
          <div className="mid-side-top">
            <div className="acc-profile">
              <div
                className="d-flex cursor-pointer"
                // onClick={() =>
                //   userItem?.user?.username === "admin"
                //     ? navigate("/user-detail")
                //     : userItem?.user?.profile_type === "student"
                //       ? navigate(
                //         `/analytics/students/student-profile/${userItem?.user?.id}`
                //       )
                //       : navigate(
                //         `/analytics/teachers/teacher-profile/${userItem?.user?.id}`
                //       )
                // }
              >
                <div className="acc-img">
                  <img src="/img/adminUser.png" alt="user" width="40" />
                </div>
                <div className="acc-content">
                  <h5 className="font-family-openSans-SemiBold">
                    {userItem?.username}
                  </h5>
                  <h6 className="font-family-openSans-Regular">
                    {userItem?.user?.profile_type}
                  </h6>
                </div>
              </div>

              <button
                className="acc-toggle"
                onClick={() => {
                  localStorage.removeItem("token");
                  localStorage.removeItem("user_id");
                  navigate("/login");
                }}
              >
                <span className="icon icon-logout" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Sidebar;
